import { convertNumbersToProperFormat } from 'utils/number';
import { getLanguageBaseOnTZ } from '../../../../../../utils/LanguageLocalStorage';

export default {
  drag: 'جابجایی',
  moveHint:
    'جهت جابجای هر آیتم لطفا شماره مکان مقصد را وارد کنید و دکمه اینتر را بزنید ',
  migrateToTagHint: 'لطفا تگ معادل هر گزینه را انخاب کنید',
  migrateToTag: 'تبدیل گزینه ها به تگ',
  searchTag: 'جستجوی تگ',
  correctAnswer: 'گزینه درست',
  paste: 'جایگذاری',
  copy: 'کپی لیست',
  copied: 'کپی شد',
  score: 'امتیاز',
  noScore: 'بدون امتیاز',
  hasScore: 'امتیاز دارد؟',
  partWeight: 'وزن گام',

  getScore(score: number) {
    const lang = getLanguageBaseOnTZ();
    return lang === 'fa' ? `${score} امتیاز` : `Score: ${score}`;
  },
};

export const getProperty = {
  choiceList: {
    choiceTitle: (count: number) => {
      return getLanguageBaseOnTZ() === 'fa'
        ? `عنوان گزینه (${convertNumbersToProperFormat(count)})`
        : `${convertNumbersToProperFormat(count)} Option Title`;
    },
    addChoice:
      getLanguageBaseOnTZ() === 'fa'
        ? 'ایجاد گزینه‌ی جدید'
        : 'Make a new choice',
  },
  parts: {
    choiceTitle: (count: number) => {
      const lang = getLanguageBaseOnTZ();
      return lang === 'fa'
        ? `عنوان گام (${convertNumbersToProperFormat(count)})`
        : `Step Title (${convertNumbersToProperFormat(count)})`;
    },
    weightTitle: (count: number) => {
      const lang = getLanguageBaseOnTZ();
      return lang === 'fa'
        ? `وزن گام (${convertNumbersToProperFormat(count)})`
        : `Step Weight (${convertNumbersToProperFormat(count)})`;
    },
    addChoice:
      getLanguageBaseOnTZ() === 'fa' ? 'ایجاد گام جدید' : 'Make a new step',
  },
};
